import type { Components, Theme } from '@mui/material';

const typographyThemeConfig: Components<Theme>['MuiTypography'] = {
  styleOverrides: {
    gutterBottom: {
      marginBottom: 12,
    },
  },
};

export const muiTypographyThemeConfig = {
  MuiTypography: {
    ...typographyThemeConfig,
  },
};
